<template>
    <div
        class="bg-primary h-16 w-screen flex justify-between z-50 fixed top-0 left-0 right-0"
    >
        <div class="flex justify-center content-center p-3">
            <div
                class="mr-10 ml-5 mt-2.5 transform scale-125 cursor-pointer"
                @click="$router.push('/')"
            >
                <img src="../../assets/logo.svg" alt="" />
            </div>
            <div class="p-2">
                <h1
                    class="
                        text-white
                        font-bold
                        overflow-ellipsis overflow-hidden
                        whitespace-nowrap
                        xs:block
                        hidden
                    "
                >
                    {{
                        GET_COURSE && GET_COURSE.name
                            ? GET_COURSE.name
                            : "WAY Yoga - Online Akademie"
                    }}
                </h1>
            </div>
        </div>

        <div class="flex justify-center h-full items-center mr-3">
            <custom-button
                @click="$router.push('/')"
                class="w-40 h-11 mr-7 hidden md:block"
                :text="'Meine Kurse'"
                :bgColor="'bg-white'"
                :textColor="'text-primary'"
                :id="'login-button'"
            >
                <template #icon>
                    <my-course-icon
                        :fillClass="'fill-primary'"
                        class="mr-4"/></template
            ></custom-button>

            <dropdown>
                <avatar-bubble class="w-11 h-11" :user="GET_USER" />
                <template #items>
                    <div
                        class="
                            flex
                            items-center
                            w-full
                            cursor-pointer
                            p-2
                            text-black
                            hover:bg-white-dark
                            md:hidden
                        "
                        @click="$router.push('/')"
                    >
                        <my-course-icon class="mr-2 w-4" fillClass="fill-black">
                        </my-course-icon>
                        {{ "Meine Kurse" }}
                    </div>
                    <div
                        class="
                            flex
                            items-center
                            w-full
                            cursor-pointer
                            p-2
                            text-black
                            hover:bg-white-dark
                        "
                        @click="LOGOUT()"
                    >
                        <logout-icon
                            class="mr-2 w-4"
                            fillClass="fill-black"
                        ></logout-icon>
                        {{ "Ausloggen" }}
                    </div>
                </template>
            </dropdown>
        </div>
    </div>
</template>

<script>
import { computed, defineComponent } from "vue";
import { useStore } from "vuex";
import {
    AUTH_TYPES,
    AUTH_USER_TYPES,
    COURSE_TYPES,
    STORE_TYPES,
} from "../../store/types";

import AvatarBubble from "../helper/AvatarBubble.vue";
import Dropdown from "../helper/Dropdown.vue";
import MyCourseIcon from "../icons/MyCourseIcon.vue";
import CustomButton from "../input/CustomButton.vue";
export default defineComponent({
    name: "Navbar",
    components: { AvatarBubble, CustomButton, Dropdown, MyCourseIcon },
    setup() {
        const store = useStore();

        const GET_USER = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.AUTH_USER}/${AUTH_USER_TYPES.GET_USER}`
                ]
        );
        const GET_COURSE = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.GET_COURSE}`
                ]
        );
        async function LOGOUT() {
            return store.dispatch(
                `${STORE_TYPES.AUTH}/${AUTH_TYPES.LOGOUT}`,
                {}
            );
        }

        return {
            GET_USER,
            GET_COURSE,
            LOGOUT,
        };
    },
});
</script>

<style></style>
